import { render, staticRenderFns } from "./PaymentPanel.vue?vue&type=template&id=22c76c7e"
import script from "./PaymentPanel.vue?vue&type=script&lang=js"
export * from "./PaymentPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports